import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Draggable } from 'react-beautiful-dnd'
import OrganizeRegItemCard from 'registry/components/reg-item-card/organize-reg-item-card'

import { moveCategorizedRegItemToNewCategory } from 'registry/actions/reg-items-actions'

const RegItemDraggable = ({
  regItem,
  index,
  categories,
  moveCategorizedRegItemToNewCategory,
}) => (
  <Draggable
    key={regItem.id}
    draggableId={`regItem-${regItem.id}`}
    index={index}
  >
    {(provided, snapshot) => (
      <div
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
      >
        <OrganizeRegItemCard
          key={regItem.id}
          onRegItemChange={({ categoryId }) =>
            moveCategorizedRegItemToNewCategory(
              regItem,
              regItem.categoryId,
              regItem.position,
              Number(categoryId)
            )
          }
          regItem={regItem}
          categories={categories}
        />
      </div>
    )}
  </Draggable>
)

RegItemDraggable.propTypes = {
  regItem: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  categories: PropTypes.array.isRequired,
}

const mapDispatchToProps = {
  moveCategorizedRegItemToNewCategory,
}

export default connect(null, mapDispatchToProps)(RegItemDraggable)
